import {
  withLayout,
  Section,
} from '@casanova/casanova-common';
import './VehiclePlatformsSituation.scss';
import VehiclePlatformSituation from './VehiclePlatformSituation';

function VehiclePlatformsSituation({
  platformsSituation
}) {

  return (
    <Section title="ESTATUS OPERATIVO DEL VEHÍCULO">
        {platformsSituation && platformsSituation.length > 0 ? (
            <div className="row">
                {platformsSituation.map((platform, index) => (
                    <VehiclePlatformSituation platform={platform} key={index}/>
                ))}
            </div>
        ) : (
            <p>No hay información disponible sobre el estatus de este vehículo en plataformas.</p>
        )}
    </Section>
  );
}

export default withLayout(VehiclePlatformsSituation, { withLoader: false });
